/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quantity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "AcceptAsk",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quantity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "AcceptBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "CancelAsk",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "CancelBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quantity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "CreateAsk",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quantity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "CreateBid",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "contract INFTContract[]",
                name: "nft",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "tokenID",
                type: "uint256[]",
            },
            {
                internalType: "bytes32[]",
                name: "id",
                type: "bytes32[]",
            },
            {
                internalType: "uint256[]",
                name: "quantity",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "feeStrategy",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "feeTakers",
                type: "address[]",
            },
        ],
        name: "acceptAsk",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INFTContract[]",
                name: "nft",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "tokenID",
                type: "uint256[]",
            },
            {
                internalType: "bytes32[]",
                name: "id",
                type: "bytes32[]",
            },
            {
                internalType: "uint256[]",
                name: "quantity",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "feeStrategy",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "feeTakers",
                type: "address[]",
            },
        ],
        name: "acceptBid",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INFTContract[]",
                name: "nft",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "tokenID",
                type: "uint256[]",
            },
            {
                internalType: "bytes32[]",
                name: "id",
                type: "bytes32[]",
            },
        ],
        name: "cancelAsk",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INFTContract[]",
                name: "nft",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "tokenID",
                type: "uint256[]",
            },
            {
                internalType: "bytes32[]",
                name: "id",
                type: "bytes32[]",
            },
        ],
        name: "cancelBid",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INFTContract[]",
                name: "nft",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "tokenID",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "price",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "quantity",
                type: "uint256[]",
            },
        ],
        name: "createAsk",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INFTContract[]",
                name: "nft",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "tokenID",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "price",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "quantity",
                type: "uint256[]",
            },
        ],
        name: "createBid",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
export class IMarketplace__factory {
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
IMarketplace__factory.abi = _abi;
